import "./Sidebar.css";
import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../../../contexts/AppContextProvider";
import { logout } from "../../../API/Auth";
import storage from "@utils/storage";
import logo from "../../../Assets/Images/Lendriva_logo.jpg";
import delete_folder from "../../../Assets/Images/deleted-folder.png";


interface ProtectedLayoutProps {
  children?: React.ReactNode;
  isOpen: boolean;
  isMenuClose: () => void;
}

const Sidebar: React.FC<ProtectedLayoutProps> = ({ isOpen, isMenuClose }) => {
  const isActivePath = (path: string) => location.pathname === path;
  const location = useLocation();
  const navigate = useNavigate();
  const Id = storage.getUser();
  const role = Id?.role;
  const userType = role;


  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    value: { user },
  } = useAppContext();

  const isOffersSubmenuActive = [
    '/app/all-offers',
    '/app/open-offers',
    '/app/approved-offers',
    '/app/completed-offers',
    '/app/canceled-offers',
    '/app/in-review-offers',
    '/app/offer-applications'
  ].some(path => isActivePath(path));

  const isApplicationSubmenuActive = [
    '/app/submitted-applications',
    '/app/rejected-applications',
    '/app/approved-applications',
    '/app/underReview-applications',
    '/app/completed-applications'
  ].some(path => isActivePath(path));

  const handleLogout = () => {
    logout();
    navigate("auth/login", { state: { userType } });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMenuOpen(window.innerWidth < 800);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (

    <>
      <div className={`${(isMenuOpen && !isOpen) ? "d-none" : "d-block"} sidebar-outer`}>
        <div className="sidebar-backdrop">
        </div>
        <div className="sidebar">
          <div className="inner-block position-relative">
            <div className="sidebar-logo">
              <img src={logo} alt="" className="img-fluid" />
            </div>
            <div className="cross position-absolute" onClick={() => isMenuClose()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <defs>
                  <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#197BBD" />
                    <stop offset="100%" stopColor="#3391D0" />
                  </linearGradient>
                </defs>
                <g>
                  <path
                    d="M15 19a1 1 0 0 1-.71-.29l-6-6a1 1 0 0 1 0-1.41l6-6a1 1 0 0 1 1.41 1.41L10.41 12l5.29 5.29A1 1 0 0 1 15 19z"
                    fill="url(#gradient)"
                    opacity="1"
                  />
                </g>
              </svg>
            </div>
            <div className="d-flex flex-column justify-content-between ul-wrapper" >
              <ul className="sidenav-list p-0">
                <li>
                  <NavLink
                    to="/app/dashboard"
                    className={`d-flex align-items-center ${isActivePath('/app/dashboard') ? 'active-link' : ''}`}
                  >
                    <div className="svg-icon">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_153_7118)">
                          <path d="M1.76835 4.00591C0.757723 5.14196 0.0945273 6.6068 0 8.22008H1.66141C1.75052 7.0583 2.21134 6.00083 2.92797 5.16553L1.76835 4.00591Z" fill="#434343" />
                          <path d="M6.81693 9.08326C6.67712 9.15384 6.58984 9.29452 6.58984 9.45054C6.59025 9.79502 7.0761 9.98205 7.306 9.72371L8.73955 8.12115L6.81693 9.08326Z" fill="#434343" />
                          <path d="M2.34766 3.42593L3.50728 4.58555C4.34257 3.86892 5.42738 3.4081 6.58916 3.31898V1.67836C4.97588 1.77286 3.48373 2.4153 2.34766 3.42593Z" fill="#434343" />
                          <path d="M7.41016 1.67836V3.31898C8.57194 3.4081 9.65675 3.86892 10.492 4.58555L11.6517 3.42593C10.5156 2.4153 9.02344 1.77286 7.41016 1.67836Z" fill="#434343" />
                          <path d="M12.2319 4.00591L11.0723 5.16553C11.7889 6.0008 12.2497 7.0583 12.3388 8.22008H14.0002C13.9057 6.6068 13.2425 5.14196 12.2319 4.00591Z" fill="#434343" />
                          <path d="M12.3247 9.04039C12.2889 9.50553 12.2114 9.96543 12.0557 10.407C11.9805 10.6196 11.7484 10.7329 11.5326 10.6578C11.3188 10.5825 11.2066 10.3482 11.2819 10.1347C11.4525 9.6504 11.539 9.14452 11.539 8.63021C11.539 7.38642 11.0331 6.2586 10.2163 5.44162C10.2162 5.44157 10.2161 5.44152 10.2161 5.44152C10.2161 5.44152 10.216 5.44127 10.2159 5.44121C9.39895 4.62437 8.24378 4.11852 7 4.11852C5.75622 4.11852 4.60105 4.6244 3.78407 5.44127C3.78402 5.44132 3.78396 5.44146 3.78396 5.44146C3.78396 5.44146 3.78372 5.4416 3.78366 5.44165C2.96682 6.2586 2.46094 7.38645 2.46094 8.63023C2.46094 9.14454 2.54745 9.65043 2.71808 10.1347C2.79338 10.3482 2.68122 10.5825 2.46734 10.6578C2.25545 10.7327 2.01994 10.6206 1.94422 10.4071C1.78855 9.96546 1.71106 9.50559 1.6753 9.04042H0C0.0586797 10.0421 0.319922 10.8899 0.68652 11.6508C0.882793 12.0581 1.31376 12.3217 1.7844 12.3217H12.2152C12.6862 12.3217 13.1172 12.0581 13.3139 11.6504C13.6759 10.8969 13.9436 10.0027 14 9.04042H12.3247V9.04039ZM10.8117 7.06571L7.91725 10.2709C7.17213 11.1043 5.76953 10.5829 5.76953 9.45055C5.76953 8.98231 6.02998 8.56089 6.4487 8.35051C6.44924 8.35026 6.44949 8.34971 6.45004 8.34947L10.3226 6.42526C10.3239 6.42461 10.3254 6.42482 10.3267 6.42417C10.7234 6.23079 11.1139 6.71817 10.8117 7.06571Z" fill="#434343" />
                        </g>
                        <defs>
                          <clipPath id="clip0_153_7118">
                            <rect width="14" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                    </div>
                    <div className="item-name">Dashboard </div>
                  </NavLink>
                </li>
                <li>
                  {userType === "lender" && (
                    <NavLink
                      className="d-flex align-items-center "

                      data-bs-toggle="collapse"
                      to="#offersSubmenu"
                      role="button"
                      aria-expanded="false"
                      aria-controls="offersSubmenu"
                    >
                      <div className="svg-icon">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.57784 0.56139C6.76629 0.237838 7.23371 0.237837 7.42216 0.561389L9.41868 3.9892C9.48772 4.10772 9.60339 4.19177 9.73745 4.2208L13.6144 5.06035C13.9804 5.13959 14.1248 5.58414 13.8754 5.86335L11.2323 8.8214C11.1409 8.92368 11.0967 9.05967 11.1105 9.19614L11.5101 13.1428C11.5478 13.5153 11.1697 13.7901 10.827 13.6391L7.19701 12.0395C7.07149 11.9842 6.92851 11.9842 6.80299 12.0395L3.17296 13.6391C2.83032 13.7901 2.45216 13.5153 2.48988 13.1428L2.88948 9.19614C2.9033 9.05967 2.85911 8.92368 2.76772 8.8214L0.12464 5.86335C-0.124841 5.58414 0.0196004 5.13959 0.385551 5.06035L4.26255 4.2208C4.39661 4.19177 4.51228 4.10772 4.58132 3.9892L6.57784 0.56139Z" fill="#434343" />
                        </svg>

                      </div>
                      <div className="item-name">Offers</div>
                    </NavLink>
                  )}
                  {userType === "borrower" && (
                    <NavLink
                      to="/app/browse-offers"
                      className={`d-flex align-items-center ${isActivePath('/app/browse-offers') ? 'active-link' : ''}`}
                    >
                      <div className="svg-icon">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.57784 0.56142C6.76629 0.237869 7.23371 0.237868 7.42216 0.561419L9.41868 3.98923C9.48772 4.10775 9.60339 4.1918 9.73745 4.22083L13.6144 5.06038C13.9804 5.13962 14.1248 5.58417 13.8754 5.86338L11.2323 8.82143C11.1409 8.92371 11.0967 9.0597 11.1105 9.19617L11.5101 13.1428C11.5478 13.5154 11.1697 13.7901 10.827 13.6391L7.19701 12.0395C7.07149 11.9842 6.92851 11.9842 6.80299 12.0395L3.17296 13.6391C2.83032 13.7901 2.45216 13.5154 2.48988 13.1428L2.88948 9.19617C2.9033 9.0597 2.85911 8.92371 2.76772 8.82143L0.12464 5.86338C-0.124841 5.58417 0.0196004 5.13962 0.385551 5.06038L4.26255 4.22083C4.39661 4.1918 4.51228 4.10775 4.58132 3.98923L6.57784 0.56142Z" fill="#434343" />
                        </svg>

                      </div>
                      <div className="item-name">Browse Offer</div>
                    </NavLink>
                  )}
                  <div className={`collapse ${isOffersSubmenuActive ? 'show' : ''}`} id="offersSubmenu">
                    <ul className="list-unstyled sub-menu-collapse">
                      <li className="item-name">
                        <NavLink
                          to="/app/all-offers"
                          className={`d-flex align-items-center ${isActivePath('/app/all-offers') ? 'active-links' : ''}`}
                        ><div className="item-name">All</div></NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/app/open-offers"
                          className={`d-flex align-items-center ${isActivePath('/app/open-offers') ? 'active-links' : ''}`}
                        ><div className="item-name">Open</div></NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/app/approved-offers"
                          className={`d-flex align-items-center ${isActivePath('/app/approved-offers') ? 'active-links' : ''}`}
                        ><div className="item-name">Approved</div></NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/app/in-review-offers"
                          className={`d-flex align-items-center ${isActivePath('/app/in-review-offers') ? 'active-links' : ''}`}
                        ><div className="item-name">In Review</div></NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/app/completed-offers"
                          className={`d-flex align-items-center ${isActivePath('/app/completed-offers') ? 'active-links' : ''}`}
                        ><div className="item-name">Completed</div></NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/app/canceled-offers"
                          className={`d-flex align-items-center ${isActivePath('/app/canceled-offers') ? 'active-links' : ''}`}
                        ><div className="item-name">Cancelled</div></NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <NavLink
                    to="/app/wallet"
                    className={`d-flex align-items-center ${isActivePath('/app/wallet') ? 'active-link' : 'inActive-link'}`}
                  >
                    <div className="svg-icon">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.71547 2.12584C5.71547 1.37197 6.32879 0.758652 7.08266 0.758652H7.55581L7.41308 0.361895C7.33283 0.13877 7.12255 0 6.89844 0C6.83635 0 6.77318 0.0106641 6.71144 0.0331406L1.9303 1.77332C1.64606 1.87679 1.49977 2.19133 1.60385 2.47535L1.85647 3.1649H5.71547V2.12584Z" fill="#434343" />
                        <path d="M7.08203 1.57896C6.77999 1.57896 6.53516 1.8238 6.53516 2.12584V3.1649H11.3203V2.12584C11.3203 1.8238 11.0755 1.57896 10.7734 1.57896H7.08203Z" fill="#434343" />
                        <path d="M12.7695 11.0536H10.8555C9.72467 11.0536 8.80469 10.1336 8.80469 9.00279C8.80469 7.87199 9.72467 6.95201 10.8555 6.95201H12.7695V5.07896C12.7695 4.47491 12.2798 3.98521 11.6758 3.98521H1.09375C0.489699 3.98521 0 4.47491 0 5.07896V12.9062C0 13.5103 0.489699 14 1.09375 14H11.6758C12.2798 14 12.7695 13.5103 12.7695 12.9062V11.0536Z" fill="#434343" />
                        <path d="M13.5898 7.77232H10.8555C10.177 7.77232 9.625 8.32431 9.625 9.00279C9.625 9.68127 10.177 10.2333 10.8555 10.2333H13.5898C13.816 10.2333 14 10.0493 14 9.8231V8.18248C14 7.95632 13.816 7.77232 13.5898 7.77232ZM10.8555 9.41295C10.629 9.41295 10.4453 9.22931 10.4453 9.00279C10.4453 8.77628 10.629 8.59264 10.8555 8.59264C11.082 8.59264 11.2656 8.77628 11.2656 9.00279C11.2656 9.22931 11.082 9.41295 10.8555 9.41295Z" fill="#434343" />
                      </svg>

                    </div>
                    <div className="item-name">Wallet</div>
                  </NavLink>
                </li>
                <li>
                  {userType === "lender" && (
                    <NavLink
                      to="/app/create-offer"
                      className={`d-flex align-items-center ${isActivePath('/app/create-offer') ? 'active-link' : ''}`}
                    >
                      <div className="svg-icon">
                        <svg
                          className="my-icon"
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <mask
                            id="mask0_153_9687"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="14"
                            height="14"
                          >
                            <rect width="14" height="14" fill="url(#pattern0_153_9687)" />
                          </mask>
                          <g mask="url(#mask0_153_9687)">
                            <rect width="14" height="14" fill="#434343" className="icon-fill" />
                          </g>
                          <defs>
                            <pattern
                              id="pattern0_153_9687"
                              patternContentUnits="objectBoundingBox"
                              width="1"
                              height="1"
                            >
                              <use xlinkHref="#image0_153_9687" transform="scale(0.0078125)" />
                            </pattern>
                            <image
                              id="image0_153_9687"
                              width="128"
                              height="128"
                              preserveAspectRatio="none"
                              xlinkHref="data:image/png;base64,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"
                            />
                          </defs>
                        </svg>


                      </div>
                      <div className="item-name">Create Offer</div>
                    </NavLink>
                  )}

                  {userType === "borrower" && (
                    <NavLink
                      className="d-flex align-items-center "

                      data-bs-toggle="collapse"
                      to="#applicationSubmenu"
                      role="button"
                      aria-expanded="false"
                      aria-controls="offersSubmenu"
                    >
                      <div className="svg-icon">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.89844 14H11.1016C11.7801 14 12.332 13.448 12.332 12.7695V4.10156H9.46094C8.78243 4.10156 8.23047 3.5496 8.23047 2.87109V0H2.89844C2.21993 0 1.66797 0.551961 1.66797 1.23047V12.7695C1.66797 13.448 2.21993 14 2.89844 14ZM4.53906 5.76953H9.46094C9.68764 5.76953 9.87109 5.95298 9.87109 6.17969C9.87109 6.40639 9.68764 6.58984 9.46094 6.58984H4.53906C4.31236 6.58984 4.12891 6.40639 4.12891 6.17969C4.12891 5.95298 4.31236 5.76953 4.53906 5.76953ZM4.53906 7.41016H9.46094C9.68764 7.41016 9.87109 7.59361 9.87109 7.82031C9.87109 8.04702 9.68764 8.23047 9.46094 8.23047H4.53906C4.31236 8.23047 4.12891 8.04702 4.12891 7.82031C4.12891 7.59361 4.31236 7.41016 4.53906 7.41016ZM4.53906 9.05078H9.46094C9.68764 9.05078 9.87109 9.23423 9.87109 9.46094C9.87109 9.68764 9.68764 9.87109 9.46094 9.87109H4.53906C4.31236 9.87109 4.12891 9.68764 4.12891 9.46094C4.12891 9.23423 4.31236 9.05078 4.53906 9.05078ZM4.53906 10.6914H7.82031C8.04702 10.6914 8.23047 10.8749 8.23047 11.1016C8.23047 11.3283 8.04702 11.5117 7.82031 11.5117H4.53906C4.31236 11.5117 4.12891 11.3283 4.12891 11.1016C4.12891 10.8749 4.31236 10.6914 4.53906 10.6914Z" fill="#434343" />
                          <path d="M9.46094 3.28125H12.0917L9.05078 0.240326V2.8711C9.05078 3.09739 9.23464 3.28125 9.46094 3.28125Z" fill="#434343" />
                        </svg>


                      </div>
                      <div className="item-name">Applications</div>
                    </NavLink>
                  )}
                  <div className={`collapse ${isApplicationSubmenuActive ? 'show' : ''}`} id="applicationSubmenu">
                    <ul className="list-unstyled sub-menu-collapse">
                      <li className="item-name">
                        <NavLink
                          to="/app/submitted-applications"
                          className={`d-flex align-items-center ${isActivePath('/app/submitted-applications') ? 'active-links' : ''}`}
                        ><div className="item-name">Submitted</div></NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/app/underReview-applications"
                          className={`d-flex align-items-center ${isActivePath('/app/underReview-applications') ? 'active-links' : ''}`}
                        ><div className="item-name">Under Review</div></NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/app/approved-applications"
                          className={`d-flex align-items-center ${isActivePath('/app/approved-applications') ? 'active-links' : ''}`}
                        ><div className="item-name">Approved</div></NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/app/rejected-applications"
                          className={`d-flex align-items-center ${isActivePath('/app/rejected-applications') ? 'active-links' : ''}`}
                        ><div className="item-name">Rejected</div></NavLink>
                      </li>

                      <li>
                        <NavLink
                          to="/app/completed-applications"
                          className={`d-flex align-items-center ${isActivePath('/app/completed-applications') ? 'active-links' : ''}`}
                        ><div className="item-name">Completed</div></NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
              <ul className="logout p-0 m-0">
                <li>
                  <NavLink to="/auth/login" data-bs-toggle="modal" data-bs-target="#exampleModal" className={({ isActive }) =>
                    `d-flex align-items-center mb-0 ${isActive ? 'active' : ''}`
                  }>
                    <div className="svg-icon">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_153_7146)">
                          <path d="M10.2598 8.89613C10.1347 8.82932 10.0566 8.69907 10.0566 8.55712V8.1726H7.36499C7.15254 8.1726 6.98047 8.0006 6.98047 7.78807V6.24999C6.98047 6.03746 7.15254 5.86547 7.36499 5.86547H10.0566V5.48095C10.0566 5.33892 10.1347 5.20866 10.2598 5.14185C10.3845 5.07536 10.5366 5.08289 10.6546 5.161L12.9617 6.69908C13.0687 6.77038 13.1329 6.89054 13.1329 7.01903C13.1329 7.14737 13.0687 7.26753 12.9617 7.33891L10.6546 8.87699C10.5353 8.95654 10.3832 8.9623 10.2598 8.89613Z" fill="#434343" />
                          <path d="M9.28734 0.815429V5.09642H7.36474C7.22639 5.09642 7.10326 5.11942 6.98022 5.16556V3.12255C6.98022 2.69181 6.74181 2.29968 6.34199 2.09204L3.02734 0.430908H8.90282C9.11823 0.430908 9.28734 0.600017 9.28734 0.815429Z" fill="#434343" />
                          <path d="M7.36499 8.94165H9.28759V11.6332C9.28759 11.8486 9.11848 12.0177 8.90307 12.0177H6.98047V8.87244C7.10352 8.91858 7.22664 8.94165 7.36499 8.94165Z" fill="#434343" />
                          <path d="M5.99616 2.77648L1.38183 0.469357C1.26656 0.415444 1.12036 0.415444 1.01269 0.484738C0.897419 0.561562 0.828125 0.684608 0.828125 0.815425V11.6332C0.828125 11.8025 0.935791 11.9486 1.08968 11.9947L5.70393 13.5328C5.8172 13.5781 5.9622 13.5525 6.04991 13.4867C6.14997 13.4098 6.21149 13.2944 6.21149 13.1714V3.12255C6.21141 2.97643 6.1269 2.84561 5.99616 2.77648ZM4.67333 7.78807C4.67333 8.00332 4.50422 8.17259 4.28881 8.17259C4.07356 8.17259 3.90429 8.00332 3.90429 7.78807V6.24998C3.90429 6.03465 4.07356 5.86546 4.28881 5.86546C4.50422 5.86546 4.67333 6.03465 4.67333 6.24998V7.78807Z" fill="#434343" />
                        </g>
                        <defs>
                          <clipPath id="clip0_153_7146">
                            <rect width="14" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                    </div>
                    <div className="item">
                      Logout
                    </div>
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="sidenav-footer position-absolute">
              <p className="m-0">Copyright © {new Date().getFullYear()} Lendriva</p>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered sidebar-modal">
          <div className="modal-content">
            <div className="delete-popup p-4">
              <div className="delete-folder-img">
                <img src={delete_folder} alt="" className="img-fluid" />
              </div>
              <h6>Are you sure you want to Logout?</h6>
              <div className="confirmation-btn d-flex align-items-center justify-content-center">
                <div className="btn-confirm" data-bs-dismiss="modal" onClick={() => {
                  handleLogout();
                }} >
                  <button type="button" className="btn-outline">Yes</button>
                </div>
                <div className="btn-confirm" data-bs-dismiss="modal">
                  <button type="button" className="button-lender no-btn">No</button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;